// Dashboard number cards — real figures only (from /company/latest-users).
// "activeUsers" from the server = companies that have verified their email.

const svg = { width: 20, height: 20, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };
const icons = {
  companies: <svg {...svg}><path d="M3 21h18" /><path d="M5 21V7l7-4 7 4v14" /><path d="M9 21v-5h6v5" /></svg>,
  verified: <svg {...svg}><circle cx="12" cy="12" r="9" /><path d="m8.5 12 2.5 2.5 4.5-5" /></svg>,
  pending: <svg {...svg}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>,
  demo: <svg {...svg}><path d="M9 3h6" /><path d="M10 3v6l-5 9a2 2 0 0 0 2 3h10a2 2 0 0 0 2-3l-5-9V3" /></svg>,
};

const formatNumber = (n) => Number(n || 0).toLocaleString('en-US');

const Header = ({ totalUsers, activeUsers, demoUsers }) => {
  const total = Number(totalUsers || 0);
  const verified = Number(activeUsers || 0);
  const pending = Math.max(total - verified, 0);

  const stats = [
    { label: 'Total Companies', value: total, icon: icons.companies, color: '#1d4ed8', bg: '#eff6ff', note: 'All registered companies' },
    { label: 'Verified', value: verified, icon: icons.verified, color: '#15803d', bg: '#f0fdf4', note: total ? `${Math.round((verified / total) * 100)}% of companies` : 'Email verified' },
    { label: 'Awaiting Verification', value: pending, icon: icons.pending, color: '#b45309', bg: '#fffbeb', note: 'Email not yet verified' },
    { label: 'In Demo Mode', value: Number(demoUsers || 0), icon: icons.demo, color: '#b45309', bg: '#fffbeb', note: 'Exploring with sample data, no plan yet' },
  ];

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 20, marginBottom: 24 }}>
      {stats.map((s) => (
        <div key={s.label} style={{
          background: '#fff',
          borderRadius: 12,
          padding: '20px 22px',
          border: '1px solid #e8ecf4',
          boxShadow: '0 1px 3px rgba(15,23,42,.04)',
          display: 'flex',
          alignItems: 'center',
          gap: 16,
        }}>
          <div style={{
            width: 44, height: 44, borderRadius: 10, background: s.bg, color: s.color,
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          }}>
            {s.icon}
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 500, color: '#64748b', marginBottom: 4 }}>
              {s.label}
            </div>
            <div style={{ fontSize: 26, fontWeight: 600, color: '#0f172a', lineHeight: 1.1, fontVariantNumeric: 'tabular-nums', letterSpacing: '-0.01em' }}>
              {formatNumber(s.value)}
            </div>
            <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>
              {s.note}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Header;
